/* Eiken — mesure de la navigation des pages collection de marque (section eiken-km-collection, 19/10/2026).
   Un événement GA4 : kc_nav, au clic d'un lien marqué data-kc-nav dans la section.
   Paramètres : kc_kind (pastille | choix | bande | encart | collections), kc_label (texte du lien, 80 caractères),
   kc_target (ancre ou adresse visée), kc_list (handle de la collection). Même envoi que eiken-menu-events.js :
   gtag du canal Google de Shopify, vers GA4 seul (send_to), après l'image qui suit le clic ; sans consentement,
   gtag n'existe pas et l'événement est ignoré. Aucune donnée personnelle. */
(function () {
  'use strict';

  function gaTarget() {
    var dl = window.dataLayer || [];
    for (var i = 0; i < dl.length; i++) {
      if (dl[i] && dl[i][0] === 'config' && /^G-/.test(dl[i][1])) return dl[i][1];
    }
    return null;
  }

  function send(params) {
    function go() {
      try {
        if (typeof window.gtag !== 'function') return;
        var p = Object.assign({ transport_type: 'beacon' }, params);
        var id = gaTarget();
        if (id) p.send_to = id;
        window.gtag('event', 'kc_nav', p);
      } catch (e) {}
    }
    var done = false;
    function once() { if (!done) { done = true; go(); } }
    if (document.visibilityState === 'hidden' || !window.requestAnimationFrame) once();
    else { requestAnimationFrame(function () { setTimeout(once, 0); }); setTimeout(once, 100); }
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-kc-nav]') : null;
    if (!a) return;
    var root = a.closest('[data-kc]');
    if (!root) return;
    send({
      kc_kind: a.getAttribute('data-kc-nav'),
      kc_label: (a.getAttribute('data-kc-label') || a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80),
      kc_target: a.getAttribute('href') || '',
      kc_list: root.getAttribute('data-kc-list') || ''
    });
  }, { passive: true });
})();

/* Barre « Choisir par usage » (.kc-chips, collante) : accrochée juste sous l'en-tête du thème quand il est visible,
   en haut de l'écran quand il se cache (19/10/2026). Motion cache l'en-tête en descendant (header--hide-on-down),
   le remontre en remontant (header--show-on-up), et sa hauteur change selon l'écran (63 à 89 px). Au-dessus, le
   bandeau d'annonce reste fixe quand il existe : l'en-tête est alors posé à top = sa hauteur (31 px), 0 sans bandeau
   (Patagonia). --kc-top = ce décalage, plus la hauteur de l'en-tête quand il est visible. Mise en page seulement. */
(function () {
  'use strict';
  var bar = document.querySelector('.kc-chips');
  var header = document.querySelector('.site-header');
  if (!bar || !header || !window.MutationObserver) return;
  function sync() {
    var shown = header.classList.contains('site-header--stuck') && !header.classList.contains('header--hide-on-down');
    var base = parseFloat(getComputedStyle(header).top) || 0;
    bar.style.setProperty('--kc-top', Math.round(base + (shown ? header.offsetHeight : 0)) + 'px');
  }
  new MutationObserver(sync).observe(header, { attributes: true, attributeFilter: ['class', 'style'] });
  window.addEventListener('resize', sync, { passive: true });
  sync();
})();

/* Points sous les rangées de sacs (19/10/2026, choix de Baptiste : « pilule qui s'allonge ») : un point par SAC (.kc-card),
   jamais pour une photo d'ambiance (.kc-tile) ; le point du sac le plus visible s'allonge. Seulement quand la rangée défile
   (téléphone) ; décoratif (aria-hidden), la rangée garde son défilement natif. */
(function () {
  'use strict';
  function setup(row) {
    if (row.getAttribute('data-kc-dots')) return;
    row.setAttribute('data-kc-dots', '1');
    var cards = [].filter.call(row.children, function (e) { return e.classList.contains('kc-card') && e.getClientRects().length; });
    if (cards.length < 2) return;
    var box = document.createElement('div');
    box.className = 'kc-dots';
    box.setAttribute('aria-hidden', 'true');
    cards.forEach(function () { box.appendChild(document.createElement('i')); });
    row.insertAdjacentElement('afterend', box);
    var dots = box.children, cur = -1, raf = 0;
    function update() {
      raf = 0;
      var on = row.scrollWidth > row.clientWidth + 4;
      box.hidden = !on;
      if (!on) return;
      var r = row.getBoundingClientRect(), best = 0, bv = -1;
      cards.forEach(function (c, i) {
        var b = c.getBoundingClientRect();
        var v = Math.max(0, Math.min(b.right, r.right) - Math.max(b.left, r.left)) / (b.width || 1);
        if (v > bv + 0.01) { bv = v; best = i; }
      });
      if (best !== cur) {
        if (cur >= 0) dots[cur].classList.remove('is-on');
        dots[best].classList.add('is-on');
        cur = best;
      }
    }
    function later() { if (!raf) raf = requestAnimationFrame(update); }
    row.addEventListener('scroll', later, { passive: true });
    window.addEventListener('resize', later, { passive: true });
    update();
  }
  [].forEach.call(document.querySelectorAll('.kc .kc-slots'), setup);
})();
